import ChevronRight from '../src/ChevronRight/index';
export default ChevronRight;
